module.exports = __webpack_public_path__ + "media/images/clube_02-cb36a8d399702a8b1de12ed0750f2284.png";